import React from "react";
import { ErrorMessage, useField } from "formik";

const FormSelect = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <div className="form-group mb-3 position-relative">
      <label htmlFor={field.name}>{label}</label>
      <select
        className={`form-select shadow-none border-none ${
          meta.touched && meta.error && "is-invalid"
        }`}
        {...field}
        // {...props}
      >
          <option value="">Select {label}</option>
        {props.data.map((item, i) => {
          return <option key={i} value={item.value}>{item.label}</option>;
        })}
      </select>

      <ErrorMessage
        component="div"
        className="theme-field-error"
        name={field.name}
      />
    </div>
  );
};
export default FormSelect;
